module.exports = __webpack_public_path__ + "img/photo-03.087f71b2.jpg";